/* eslint-disable camelcase */
export const en = {
  AdminDashboard: {
    expiringLicenses: {
      popupHeader: "Attention",
      title: "List of accounts whose license expires within %cnt% days",
      understandButton: "I understand",
    },
    ActivitiesList: {
      labStatus: {
        error: "error",
        success: "ok",
      },
      labels: {
        action: "Action",
        context: "Description",
        date: "Date",
        errorMsg: "Error description",
        executor: "Executor",
        status: "Status",
      },
    },
    Licence: {
      deletePopup: {
        confirmationText: "Yes, I want to delete the license",
        contentText:
          "After deleting the license, it will not be possible to assign examinations",
        headerText: "Are you sure you want to delete the license?",
      },
      labels: {
        expireDate: "License expiry date",
        licenseDate: "License issue date",
        methodologyList: "Available methodologies",
        testsList: "Available tests",
      },
    },
    PsychLab: {
      anonymizePopup: {
        headerText: "Are you sure you want to anonymize client data?",
        contentText:
          "All examinations and examinee data will be anonymized and moved to the Psychometric account (new and incomplete examinations will be deleted). This operation cannot be undone. Do you want to continue?",
        confirmationText: "Yes, I want to anonymize data",
      },
      deletePopup: {
        confirmationText: "Yes, I want to delete the client account",
        contentText:
          "After deleting the client account, it will not be possible to restore the data",
        headerText: "Are you sure you want to delete the client account?",
      },
    },
    PsychLabManagment: {
      PsychLabView: {
        labels: {
          details: "Details",
          download: "Download",
          edit: "Edit",
          generate: "Generate",
          name: "Test name",
          nameFile: "File name",
          print: "Print",
          result: "Result",
          type: "Document type",
        },
        tabs: {
          activityAction: "action name",
          activityContext: "description",
          activityDate: "date",
          activityExecutor: "executor",
          activityId: "ID",
          activityLogs: "Activity logs",
          activityLogsFile: "activity_logs",
          activityStatus: "Status",
          license: "License",
          psychLabData: "Client data",
          stats: "Statistics",
          theme: "Appearance",
          parameters: "Parameters",
          priceList: "Price list",
          users: "Users",
        },
        parameters: {
          header: "Client parameters",
          noParameters:
            "No parameters available for this client. Check if the license is active.",
        },
      },
      breadcrumbs: {
        add: "Add client account",
        addLicense: "Add license",
        addUser: "Add user account",
        dashboard: "User panel",
        edit: "Edit client account",
        editLicense: "Edit license",
        editUser: "Edit user account",
        psychLabs: "Client records",
      },
      header: {
        add: "Add client account",
        addLicense: "Add license",
        addUser: "Add user account",
        edit: "Edit client account",
        editLicense: "Edit license",
        editUser: "Edit user account",
      },
    },
    PsychologicalLabsList: {
      labStatus: {
        disabled: "inactive",
        enabled: "active",
      },
      labels: {
        all: "all",
        clientId: "Client ID",
        createDate: "Creation date",
        details: "Details",
        examinationsCnt: "Number of examinations",
        examineesCnt: "Number of examinees",
        expireDate: "Account expiry date",
        licenseExpireDate: "License expiry date",
        moreThen: "more than",
        name: "Client name",
        of: "of",
        psychCnt: "Number of users",
        status: "Status",
        systemAccount: "system account",
        taskPerPage: "Rows per page:",
        usersCnt: "Number of users",
      },
      expiryWarningTooltip:
        "License expiry date or account expiry date expires within %count% days",
      expiredWarningTooltip:
        "The license expiry date or account expiry date has passed",
      inactiveAccountTooltip: "Inactive account",
    },
    StatsList: {
      statFileName: "examination_statistics.xlsx",
    },
    UsersList: {
      deletePopup: {
        confirmationText: "Yes, I want to delete the user account",
        contentText:
          "After deleting the user account, it will not be possible to restore it",
        headerText: "Are you sure you want to delete the user account?",
      },
      labStatus: {
        adminRole: "administrator",
        disabled: "inactive",
        enabled: "active",
        superUserRole: "super admin",
        userBaseRole: "registrar",
        userRole: "user",
      },
      labels: {
        email: "Email",
        examinationCnt: "Number of examinations (all / assigned / completed)",
        examinationCnt1: "Number of examinations",
        examinationCnt2: "all: ",
        examinationCnt3: "assigned: ",
        examinationCnt4: "completed: ",
        examineeCnt: "Number of participants",
        firstName: "First name",
        isActive: "Status",
        isStaff: "Role",
        lastName: "Last name",
      },
      toolTip: {
        move: "move examinations and folders",
        delete: "delete",
        edit: "edit",
      },
    },
    emptyState: {
      header: "No client accounts added yet",
      info: "To see the list of clients, add at least one account.",
    },
    emptyStateLicense: {
      header: "No licenses added yet",
      info: "To see the license, please add it.",
    },
    emptyStateUsers: {
      header: "No user accounts added yet",
      info: "To see the list of users, add at least one user account.",
    },
    header: "Client Records",
    showInactiveAccounts: "Show inactive accounts",
    kebabMenu: {
      print: "Print contract",
      profile: "Go to examinee profile",
    },
  },
  AdminSearchEngine: {
    enterFilter:
      "You can search by name, ID, address, tax ID number, creation date, client account expiry date in YYYY-MM-DD format, user's first name, last name, email, license expiry date in YYYY-MM-DD format, methodology, test.",
    header: "Search clients",
    noResults: "No search results",
    noResultsForFilter: "No clients found matching the entered requirements.",
    placeholderDesktop:
      "name, ID, address, tax ID number, creation date, client account expiry date in YYYY-MM-DD format, user's first name, last name, email, license expiry date, methodology, test",
    placeholderMobile: "Search",
    searchForExaminees: "Search clients",
  },
  ArchiveExaminationList: {
    emptyState: {
      info: "There are no archival assessments assigned to this participant",
    },
  },
  Backend: {
    Could_not_bind_users_PsychologicalLab_with_the_directory:
      "It was not possible to link the user's facility with the folder.",
    Could_not_bind_users_PsychologicalLab_with_the_examinee:
      "It was not possible to link the user's facility with the participant.",
    Directory_has_related_Examinees:
      "Unable to delete Folder Folder has participants associated with it.",
    Directory_with_given_name_already_exists:
      "A folder with this name already exists.",
    Examination_Card_does_not_have_a_defined_NormSet:
      "The examination card does not have an assigned norm.",
    Examinee_with_the_given_id_exists_in_this_psychological_lab:
      "A participant with the given ID already exists.",
    Generated_ID_conflict: "Error generating identifier for the examinee.",
    Incorrect_credentials: "Invalid password",
    Invalid_token_Please_regenerate_password_reset_link:
      "Invalid token, please generate a new password reset link.",
    Legacy_data_instance_not_found: "No archived data found.",
    Legacy_data_validation_failed: "Validation error: archive data.",
    Ongoing_examination:
      "It is not possible to delete the assessment. Assessment in progress.",
    User_has_related_Examinations_or_Directories:
      "Unable to delete User: User has related examinations or directories.",
    The_Examinee_has_related_Examinations:
      "Unable to delete Participant Participant has assessments associated with it.",
    The_new_pin_cannot_be_the_same_as_the_previous_one:
      "The new PIN cannot be the same as the previous one.",
    The_password_cannot_be_the_same_as_the_previous_one:
      "The password cannot be the same as the previous one.",
    Token_not_recognized: "The token was not recognized.",
    Unable_to_delete_default_directory:
      "It is not possible to delete the Default folder.",
    Unable_to_parse_Examination_Aim: "Validation error: Purpose of assessment.",
    Unable_to_parse_Occupational_Medicine_Basic_Info_data:
      "Validation error: Assessment - Occupational Medicine.",
    Unrecognized_email:
      "The email address was not recognized or the account was not activated.",
    Unrecognized_proxy_error_occurred_while_fetching_legacy_data:
      "Unrecognized error downloading archival assessments.",
    Unrecognized_token_Please_regenerate_password_reset_link:
      "Unrecognized token, please generate a new password reset link.",
    User_activation_code_does_not_exist:
      "The provided activation code does not exist.",
    User_activation_code_has_already_been_used:
      "The activation code has already been used.",
    User_with_given_id_does_not_exist:
      "The user with the given id does not exist.",
    Validation_failed: "Validation of entered data failed.",
  },
  Buttons: {
    accept: "Agree",
    addDirectory: "Add folder",
    addExaminee: "Add participant",
    addMobileExaminee: "Add",
    addPsychLab: "Add customer",
    addPsychLabLic: "Add license",
    addPsychUser: "Add user",
    addPsychUserMobile: "Add user",
    addUser: "Add user",
    alreadyAssigned: "Assigned",
    alreadyAssignedExamination: "Assessment in progress",
    assign: "Assign",
    assignExamination: "Assign assessment",
    back: "Back",
    backToLogin: "Back to login page",
    begin: "Start",
    cancel: "Cancel",
    change: "Change",
    clear: "Clear",
    close: "Close",
    confirm: "Confirm",
    continue: "Next",
    createExamination: "Create assessment",
    delete: "Delete",
    anonymize: "Anonymize",
    deleteExaminee: "Delete participant",
    deleteExaminees: "Delete participants",
    anonymizePsychLab: "Anonymize data",
    deletePsychLab: "Delete customer",
    deletePsychLabLic: "Delete license",
    disable2FA: "Disable",
    downloadAll: "Download all",
    edit: "Edit participant",
    editExaminee: "Edit participant",
    editPsychLab: "Edit customer",
    editPsychLabLic: "Edit license",
    editPsychLabUser: "Edit user",
    enable2FA: "Enable",
    examinationWithLawBase: "Assessment with a legal basis",
    examinationWithNoLawBase: "Assessment without a legal basis",
    exit: "Exit",
    exportActivities: "Export to XLS",
    exportResults: "Generate export",
    generate: "Generate",
    generateAndPrint: "Generate and print",
    go: "Go",
    goToDashboard: "Go to user panel",
    importExaminees: "Import examinees",
    login: "Login",
    loginPsychLab: "Log in to client account",
    move: "Move",
    moveExaminee: "Move participant",
    moveExaminees: "Move participants",
    examineesIdsList: "Download examinees list",
    ok: "OK",
    print: "Print",
    printContract: "Print contract",
    save: "Save",
    saveAndInvate: "Save and invite",
    saveAndPrint: "Save and print",
    savePassword: "Save password",
    savePin: "Save PIN",
    saveSettings: "Save settings",
    search: "Search",
    sendEmail: "Send message",
    sendLink: "Send link",
    setNewPassword: "Set new password",
    setPassword: "Set password",
    setPin: "Set PIN",
    showActivities: "Show",
    skipTests: "Skip tests",
    understood: "Understood",
    unblockedExam: "Unblock examinations",
    enable2FAIcon: "Enable two-factor authentication",
    disable2FAIcon: "Disable two-factor authentication",
    openFolder: "Open",
  },
  Common: {
    deleteExamineePopup: {
      header: "Are you sure you want to delete the participant?",
      text: "Once the participant is deleted, it will not be possible to restore the data",
      confirmationText: "Yes, I want to delete the participant",
    },
    deleteExamineesPopup: {
      header: "Are you sure you want to delete the selected participants?",
      text: "Once the participants are deleted, it will not be possible to restore the data",
      confirmationText: "Yes, I want to delete the participants",
    },
    deleteExamineeWithExamPopup: {
      header:
        "Are you sure you want to delete the participant together with their examinations?",
      text: "Once the participant is deleted together with their examinations, it will not be possible to restore the data",
      confirmationText:
        "Yes, I want to delete the participant together with their examinations",
    },
    deleteExamineesWithExamPopup: {
      header:
        "Are you sure you want to delete the selected participants together with their examinations?",
      text: "Once the participants are deleted together with their examinations, it will not be possible to restore the data",
      confirmationText:
        "Yes, I want to delete the participants together with their examinations",
    },
    logAdminAsUserPopup: {
      header: "Error",
      text: "Failed to log in to client account",
    },
    menu: {
      breadcrumbsPsychLab: "Client records",
      contact: "Help",
      dashboard: "User panel",
      emailSender: "Sending a message",
      exportResults: "Export results",
      examineeRegistry: "Examinee registry",
      folders: "Examinee records",
      importExaminees: "Import examinees",
      logout: "Log out",
      psychlabs: "Client records",
      search: "Search",
      settings: "Settings",
      priceList: "Price list",
      summary: "Examinee registry",
    },
    seo: {
      addExaminee: "Add participant",
      addPsychLab: "Add client account",
      addPsychLabLic: "Add license",
      dashboard: "User panel",
      editExaminee: "Edit participant",
      emailSender: "Sending a message",
      examinationAssignment: "Examination assignment with legal basis",
      examinationCard: "Examination card",
      exportResults: "Export results",
      folders: "Folders",
      helpdesk: "Help",
      helpdeskDocuments: "Help documents",
      judgement: "Judgment",
      login: "Login",
      onboarding: "Onboarding",
      report: "Report",
      resetPassword: "Reset password",
      search: "Search",
      setNewPassword: "Set new password",
      settings: "Settings",
      priceList: "Price list",
    },
    twoFactorAuth: "Two-Factor Authentication",
    warningPopup: {
      header: "Are you sure you want to leave?",
      headerSave: "Please complete all required fields!",
      promptLogout:
        "You will be automatically logged out in PROMPT_TIME_MINUTES minute due to inactivity.",
      promptLogoutCountdown:
        "You will be automatically logged out in COUNTDOWN_TIME due to inactivity.",
      logoutWarningTitle: "Your session is about to expire",
      promptLogoutInfo:
        "Due to inactivity, you will be automatically logged out in one minute.",
      stayLoggedIn: "Extend session",
      logoutNow: "Log out now",
      text: "The changes you make will not be saved",
      textSave: "Required fields may also be located on other tabs",
    },
  },
  Contact: {
    header: "Technical Support",
  },
  WhatsNew: {
    closeButton: "Got it",
  },
  LicenseExpire: {
    popup: {
      header: "Attention!",
      messageManyDaysBold: "License or account validity expires in %cnt% days.",
      messageOneDayBold: "License or account validity expires in %cnt% day.",
      messageRest:
        "Contact us to maintain continuity of work and access to all system functions.",
      understandButton: "I understand",
      dontShowAgain: "Don't show again",
    },
    expiredPopup: {
      header: "License expired",
      message:
        "Your license to perform tests in the Optimis system has expired.",
      okButton: "OK",
    },
  },
  Cookies: {
    consent:
      "In order to provide the highest quality services, we use cookies. Using our website means that they will be stored on your device. You can change your browser settings at any time.",
    cookiePolicy: {
      moduleText1:
        "The service uses cookies. In the following document, we inform about the use of cookies in the Optimis service.",
      moduleText10:
        "Menu > Preferences > Privacy > Cookies – select the appropriate option.",
      moduleText2:
        "Cookies are small fragments of text, code, which are sent to the browser and which the browser sends back. Some cookies are sometimes saved on a given device while browsing the Optimis service. There are different types of cookies. Cookies used in the Optimis service have been divided into the following categories:\n      a. necessary cookies\n      b. functional\n      c. analytical",
      moduleText3:
        "a. Cookies that are necessary for using the Optimis service, serve, among others, to ensure the stability of its functioning (they measure traffic and protect us from overload). These cookies are absolutely necessary for the Optimis service to provide services, and/or solely for the purpose of transmitting services and/or the Optimis service.\n      b. Functional cookies - remembering selected privacy preferences, online form completions, remembering website settings.",
      moduleText4:
        "When visiting the www.gov.pl website, a message will be displayed informing that it uses cookies.",
      moduleText5:
        "In most internet browsers, you can: delete cookies from your computer's hard drive (from the browser settings), block all sent cookies, or set a warning before saving them on the disk.\n      It should be noted that changes to these file settings involving limiting their use may affect some functionalities available on the websites that use them.\n      Below we indicate how to change cookie settings in the most popular browsers:",
      moduleText6:
        "Menu > Settings > Privacy and security – select the appropriate option.",
      moduleText7:
        "Menu > Settings > Cookies and site permissions – select the appropriate option.",
      moduleText8:
        "Menu > Preferences > Privacy and Security > Cookies and Site Data – select the appropriate option.",
      moduleText9:
        "Menu > Settings > Privacy and security – select the appropriate option.",
      moduleTitle1: "1. Introduction",
      moduleTitle10: "Safari",
      moduleTitle2: "2. What are cookies?",
      moduleTitle3: "3. What cookies do we use?",
      moduleTitle4: "4. Consent to the use of cookies",
      moduleTitle5: "5. Modifying cookie settings",
      moduleTitle6: "Google Chrome",
      moduleTitle7: "Internet Explorer",
      moduleTitle8: "Mozilla Firefox",
      moduleTitle9: "Opera",
      title: "Cookie Policy",
    },
    header: "Permission to use cookies",
    policy: "Cookie policy",
    showPolicy: "View cookie policy",
  },
  Dashboard: {
    emptyState: {
      header: "No recently added participants",
      info: "To see the list of assessment, assign at least one assessment.",
    },
    footer: {
      day: "day",
      days: "days",
      lastFailedLogin: "Last failed login",
      lastLogin: "Last login",
      passwordExpired: "Your password will expire in",
      versionLabel: "Version",
    },
    header: "Recently added participants",
    kebabMenu: {
      print: "Print contract",
      profile: "Go to the participant's profile",
    },
  },
  Directory: {
    defaultFolderName: "Default folder",
    emptyState: {
      header: "No examinees in selected folder",
      info: "To see the list of examinees in the folder, add at least one examinee",
    },
    header: "Examinee Records",
    kebabMenu: {
      addDirectory: "Add folder",
      addExaminee: "Add examinee",
      delete: "Delete folder",
      edit: "Edit folder name",
    },
    labels: {
      examineeCount: "People",
      name: "Folder name",
      owner: "Owner",
    },
    popup: {
      create: "Enter folder name",
      edit: "Change folder name",
    },
    popups: {
      delete: {
        confirmationHeader: "Are you sure you want to delete the folder?",
        confirmationText: "Once deleted, the folder cannot be restored.",
        confirmationCheckboxLabel: "Yes, I want to delete the folder",
      },
    },
  },
  DirectoryPreview: {
    breadcrumbs: "Examinee records",
    headerPopup: "Move examinees",
    kebabMenu: {
      delete: "Delete examinee",
      edit: "Edit examinee data",
      move: "Move examinee",
    },
    labels: {
      firstName: "First name",
      lastModification: "Last activity",
      lastName: "Last name",
      peselSlashIdentifier: "ID Number / Identifier",
    },
  },
  MoveExamAndFoldersPopup: {
    header: "Move examinations and folders",
    userInfo: "User information",
    examinations: "Number of examinations",
    examAll: "all examinations",
    examAssign: "assigned examinations",
    examDone: "completed examinations",
    directories: "User folders",
    noDirectories: "No folders",
    selectTargetUser:
      "Select the user to whom you want to transfer the examinations and folders",
    selectTargetUserLabel: "Target user",
    noActiveUsers: "No active users",
    moveButton: "Move",
  },
  DocumentationManagement: {
    ExaminationCard: {
      examinationCourse: {
        addExaminationExtendedResults: "Add additional result",
        careerHistory: "Work history",
        cognitiveExtendedResultsHeader:
          "Assessment and description of examinee's intellectual capacity and cognitive processes - additional results",
        cognitiveResultsHeader:
          "Assessment and description of examinee's intellectual capacity and cognitive processes (within recommended methodology)",
        conclusions: "Conclusions",
        conclusionsRecomendation: "Conclusions and recommendations",
        deletePopup: {
          confirmationText: "Yes, I want to delete the result",
          contentText:
            "After deleting the result, you can restore its original content by updating the data",
          headerText: "Are you sure you want to delete this result?",
        },
        examinationExtendedResultsHeader: "Test name and additional results",
        examinationExtendedResultsT2WHeader: "Additional",
        examinationResultsHeader:
          "Test name and results (within recommended methodology)",
        examinationResultsT2WHeader: "Recommended methodology",
        forcedUpdateBody:
          "To unlock the form, complete the Examination Interview, select a standard in the Examinee tab and update the Examination Card with Interview Data and Results.",
        forcedUpdateHeader:
          "Update Examination Card with Interview Data and Results",
        header: "Data from direct interview and observation of the examinee",
        methodology: "Examination methods and results",
        occupationalMedicineAdditionalInfo:
          "Additional information - Occupational Medicine",
        personalityExtendedResultsHeader:
          "Assessment and description of examinee's personality, including functioning in difficult situations and social maturity - additional results",
        personalityResultsHeader:
          "Assessment and description of examinee's personality, including functioning in difficult situations and social maturity (within recommended methodology)",
        psychomotorExtendedResultsHeader:
          "Psychomotor performance - additional results",
        psychomotorResultsHeader:
          "Psychomotor performance (within recommended methodology)",
        recommendations: "Recommendations",
      },
      examinee: {
        aim: "Purpose of examination",
        chosenNormSet: "Standard applied in examination",
        entityDirectingToExamination: "Entity referring for examination",
        examinationDate: "Examination Date",
        previousExaminationDate: "Previous examination date",
        t2dAim: {
          drivingInstructorAim:
            "Determination of absence or presence of contraindications for performing duties of instructor/examiner/driving technique instructor.",
          drivingVehiclesAim:
            "Determination of absence or presence of contraindications for operating vehicles.",
          emergencyDriverAim:
            "Determination of absence or presence of contraindications for operating emergency vehicles or cash-in-transit vehicles.",
          professionalDriverAim:
            "Determination of absence or presence of contraindications for working in the position of driver.",
        },
      },
      fetchUpdated: "Update with interview data and results",
      header: "Examination Card",
      headerTEST2ARMS: "Examination Card TEST2ARMS",
      headerTEST2DRIVE: "Examination Card TEST2DRIVE",
      headerTEST2SAFE: "Examination Card TEST2SAFE",
      headerTEST2WORK: "Examination Card TEST2WORK",
      judgment: {
        judgment: "Assessment content",
        justification: "Assessment justification",
        justificationText: "Justification content",
        recommendations: "Recommendations",
        result: "Psychological examination result",
        sent: "Assessment/copy of assessment sent, if applicable",
        t2d: {
          existing: "exists",
          lack: "none",
          questions: {
            drivingInstructorContraindication:
              "Contraindications for performing duties of instructor/examiner/driving technique instructor.",
            drivingVehiclesContraindication:
              "Contraindications for operating vehicles.",
            emergencyVehicleDriverContraindication:
              "Contraindications for operating emergency vehicles or cash-in-transit vehicles.",
            professionalDriverContraindication:
              "Contraindications for working in the position of driver.",
          },
        },
        to: "to",
      },
      tabs: {
        courseOfExamination: "Course of Examination",
        examinee: "Examinee",
        results: "Psychological Examination Results",
      },
      tooltipFetchUpdated:
        "This action will delete all unsaved changes from the Examination Course",
      tooltipFetchUpdatedDisabled:
        "To unlock this action, select examination standard.",
    },
    consultation: {
      breadcrumbs: "Psychological Consultation",
      examineeData: "Examinee Data",
      statement: "I hereby state",
    },
    emptyState: {
      header: "Examination has not been completed",
    },
    judgment: {
      ART_1: "Article 39k paragraph 3 point 1",
      ART_2: "Article 39k paragraph 3 point 2",
      appeal: "This assessment may be appealed to",
      appealDate: "Within",
      appealDay: "Within",
      appealDay2: "days from the date of receipt",
      appealDayTlt: "Number of days",
      civilExplosives: {
        false:
          "shows psychological dysfunction and therefore may not engage in activities related to acquisition and storage of explosives intended for civil use",
        true: "shows no psychological dysfunction and therefore may engage in activities related to acquisition and storage of explosives intended for civil use",
      },
      drivingExaminer: {
        false:
          "contraindications exist for performing duties of instructor/examiner/driving technique instructor",
        true: "no contraindications for performing duties of instructor/examiner/driving technique instructor",
      },
      drivingInstructor: {
        false:
          "contraindications exist for performing duties of instructor/examiner/driving technique instructor",
        true: "no contraindications for performing duties of instructor/examiner/driving technique instructor",
      },
      drivingLicense: "Regarding driving license category",
      drivingVehicles: {
        false: "psychological contraindications exist for operating vehicles",
        true: "no psychological contraindications for operating vehicles",
      },
      emergencyVehicleDriver: {
        false:
          "contraindications exist for operating emergency vehicles or cash-in-transit vehicles",
        true: "no contraindications for operating emergency vehicles or cash-in-transit vehicles",
      },
      examiner_ART_1: "Article 34 paragraph 5 point 1",
      examiner_ART_2: "Article 34 paragraph 5 point 2",
      firearmLicense: {
        false:
          "belongs to persons mentioned in Art. 15 par. 1 point 3 of the Act of May 21, 1999 on weapons and ammunition and may not possess firearms",
        true: "does not belong to persons mentioned in Art. 15 par. 1 point 3 of the Act of May 21, 1999 on weapons and ammunition and may possess firearms",
      },
      header: {
        base: "Assessment",
        baseAppeal: "Appeal Assessment",
        baseAppealFooter: "This assessment is final.",
        civilExplosives: "Licensed Activity - for Civil Use",
        civilExplosivesAppeal: "Licensed Activity - for Civil Use - Appeal",
        driver: "Vehicle Operation",
        drivingExaminer: "Examiner",
        drivingInstructor: "Instructor",
        emergencyVehicleDriver: "Emergency Vehicle Driver",
        firearmLicense: "Firearm License",
        militaryExplosives: "Licensed Activity - for Military or Police Use",
        occupationalMedicine: "Occupational Medicine",
        physicalProtection: "Security Officer",
        profesionalDriver: "Professional Driver Position",
      },
      isAppealTitle: "APPEAL ASSESSMENT",
      judgmentNumber: "Psychological assessment No.",
      judgmentNumberAppeal: "Psychological assessment No.",
      legalBais: "Legal basis for examination",
      militaryExplosives: {
        false:
          "shows significant psychological dysfunction that prevents conducting or managing business activities in manufacturing and trading of explosives, weapons, ammunition, and products and technology for military or police use",
        true: "shows no significant psychological dysfunction that would prevent conducting or managing business activities in manufacturing and trading of explosives, weapons, ammunition, and products and technology for military or police use",
      },
      nextLegalBasis: "Legal basis for next examination:",
      occupationalMedicine: {
        false: "psychological contraindications exist for",
        justification: "Justification",
        true: "no psychological contraindications for",
      },
      occupationalMedicineStatement: "I hereby declare*",
      physicalProtection: {
        false: "is not capable of performing physical security officer duties",
        true: "is capable of performing physical security officer duties",
      },
      professionalDriver: {
        false:
          "psychological contraindications exist for working in the position of driver",
        true: "no psychological contraindications for working in the position of driver",
      },
      remarks: "Remarks",
      statement: "I hereby state*",
      statementThat: "I hereby state that",
    },
    names: {
      CivilExplosivesJudgment:
        "Judgment on weapons and explosives for civil use",
      CivilExplosivesJudgmentTEST2ARMS:
        "Judgment on weapons and explosives for civil use",
      CivilExplosivesJudgmentTEST2DRIVE:
        "Judgment on weapons and explosives for civil use",
      CivilExplosivesJudgmentTEST2SAFE:
        "Judgment on weapons and explosives for civil use",
      CivilExplosivesJudgmentTEST2WORK:
        "Judgment on weapons and explosives for civil use",
      DriverJudgment: "Driver Assessment",
      DriverJudgmentTEST2ARMS: "Driver Assessment",
      DriverJudgmentTEST2DRIVE: "Driver Assessment",
      DriverJudgmentTEST2SAFE: "Driver Assessment",
      DriverJudgmentTEST2WORK: "Driver Assessment",
      DrivingExaminerJudgment: "Driving Examiner Assessment",
      DrivingExaminerJudgmentTEST2ARMS: "Driving Examiner Assessment",
      DrivingExaminerJudgmentTEST2DRIVE: "Driving Examiner Assessment",
      DrivingExaminerJudgmentTEST2SAFE: "Driving Examiner Assessment",
      DrivingExaminerJudgmentTEST2WORK: "Driving Examiner Assessment",
      DrivingInstructorJudgment: "Driving Instructor Assessment",
      DrivingInstructorJudgmentTEST2ARMS: "Driving Instructor Assessment",
      DrivingInstructorJudgmentTEST2DRIVE: "Driving Instructor Assessment",
      DrivingInstructorJudgmentTEST2SAFE: "Driving Instructor Assessment",
      DrivingInstructorJudgmentTEST2WORK: "Driving Instructor Assessment",
      DrivingTechniqueInstructorJudgment:
        "Driving Technique Instructor Assessment",
      EmergencyVehicleDriverJudgment: "Emergency Vehicle Driver Assessment",
      EmergencyVehicleDriverJudgmentTEST2ARMS:
        "Emergency Vehicle Driver Assessment",
      EmergencyVehicleDriverJudgmentTEST2DRIVE:
        "Emergency Vehicle Driver Assessment",
      EmergencyVehicleDriverJudgmentTEST2SAFE:
        "Emergency Vehicle Driver Assessment",
      EmergencyVehicleDriverJudgmentTEST2WORK:
        "Emergency Vehicle Driver Assessment",
      ExaminationCard: "Examination Card",
      ExaminationCardTEST2ARMS: "Examination Card TEST2ARMS",
      ExaminationCardTEST2DRIVE: "Examination Card TEST2DRIVE",
      ExaminationCardTEST2SAFE: "Examination Card TEST2SAFE",
      ExaminationCardTEST2WORK: "Examination Card TEST2WORK",
      FirearmLicenseJudgment: "Firearm License Assessment",
      FirearmLicenseJudgmentTEST2ARMS: "Firearm License Assessment",
      FirearmLicenseJudgmentTEST2DRIVE: "Firearm License Assessment",
      FirearmLicenseJudgmentTEST2SAFE: "Firearm License Assessment",
      FirearmLicenseJudgmentTEST2WORK: "Firearm License Assessment",
      MilitaryExplosivesJudgment:
        "Police/Military Weapons and Explosives Assessment",
      MilitaryExplosivesJudgmentTEST2ARMS:
        "Police/Military Weapons and Explosives Assessment",
      MilitaryExplosivesJudgmentTEST2DRIVE:
        "Police/Military Weapons and Explosives Assessment",
      MilitaryExplosivesJudgmentTEST2SAFE:
        "Police/Military Weapons and Explosives Assessment",
      MilitaryExplosivesJudgmentTEST2WORK:
        "Police/Military Weapons and Explosives Assessment",
      OccupationalMedicineJudgmentTEST2ARMS: "Occupational Medicine Assessment",
      OccupationalMedicineJudgmentTEST2DRIVE:
        "Occupational Medicine Assessment",
      OccupationalMedicineJudgmentTEST2SAFE: "Occupational Medicine Assessment",
      OccupationalMedicineJudgmentTEST2WORK: "Occupational Medicine Assessment",
      PhysicalProtectionJudgment: "Security Guard License Assessment",
      PhysicalProtectionJudgmentTEST2ARMS: "Security Guard License Assessment",
      PhysicalProtectionJudgmentTEST2DRIVE: "Security Guard License Assessment",
      PhysicalProtectionJudgmentTEST2SAFE:
        "Physical Security Officer Assessment",
      PhysicalProtectionJudgmentTEST2WORK: "Security Guard License Assessment",
      ProfessionalDriverJudgment: "Professional Driver Position Assessment",
      ProfessionalDriverJudgmentTEST2ARMS:
        "Professional Driver Position Assessment",
      ProfessionalDriverJudgmentTEST2DRIVE:
        "Professional Driver Position Assessment",
      ProfessionalDriverJudgmentTEST2SAFE:
        "Professional Driver Position Assessment",
      ProfessionalDriverJudgmentTEST2WORK:
        "Professional Driver Position Assessment",
      PsychologicalConsultation: "Psychological Consultation",
      PsychologicalConsultationTEST2ARMS: "Psychological Consultation",
      PsychologicalConsultationTEST2DRIVE: "Psychological Consultation",
      PsychologicalConsultationTEST2SAFE: "Psychological Consultation",
      PsychologicalConsultationTEST2WORK: "Psychological Consultation",
      PsychologicalOpinion: "Psychological Opinion",
      PsychologicalOpinionTEST2ARMS: "Psychological Opinion",
      PsychologicalOpinionTEST2DRIVE: "Psychological Opinion",
      PsychologicalOpinionTEST2SAFE: "Psychological Opinion - Detectives",
      PsychologicalOpinionTEST2WORK: "Psychological Opinion",
    },
    opinion: {
      breadcrumbs: "Psychological Opinion",
      breadcrumbsAppeal: "Appeal Psychological Opinion",
      examineeData: "Examinee Data",
      statement:
        "BASED ON THE CONDUCTED PSYCHOLOGICAL EXAMINATION, I HEREBY STATE",
    },
    report: {
      details: {
        PESEL: "ID Number",
        assignDate: "Examination assignment date",
        endDate: "Examination completion date",
        firstName: "First name",
        idExamination: "Examination ID",
        identificationNumber: "Identifier",
        lastName: "Last name",
        name: "Examination name",
        status: "Examination status",
      },
      header: {
        interval: "Select confidence interval",
        language: "Select report language",
        recipient: "Select recipient",
        reportDiagnostic: "Diagnostic report",
        reportDiagnosticCharts: "Diagnostic report with charts",
        reportInterpretation: "Interpretative report",
        standard: "Select standard",
      },
      statusExamination: {
        skip: "Some tests were skipped or interrupted",
      },
    },
    snackbar: {
      save: "Document saved successfully",
    },
  },
  Email: {
    bodybreak:
      '<div style="color: #000000; font-family: Arial;font-size:12pt;line-height: 1.5rem;">\n  <p>Dear Sir/Madam,<br/><br/>\n  We would like to inform you that on <strong>[date, e.g., June 30, 2025]</strong> between <strong>[e.g., 22:00 - 02:00]</strong> we will conduct planned technical maintenance to update our system.<br/>During the work, access to the Optimis system may be temporarily limited or unavailable. Please plan your work with the system taking into account this maintenance period<br /><br />\n  \n  We apologize for any inconvenience and thank you for your understanding.<br /><br />If you have any questions, please contact us<br/>email: <strong>alta@alta.pl</strong><br/>phone:<strong>(+48) 515 131 941</strong><br /><br />\n  \n  This message was generated automatically - please do not reply to it.\n  <br/><br>\n  Best regards,\n  ALTA Team </p>\n  </div>',
    bodysys:
      '<div style="color: #000000; font-family: Arial;font-size:12pt;line-height: 1.5rem;">\n  <p>Dear Sir/Madam,<br/><br/>\n  We would like to inform you that during the holiday period, from <strong>December 24, 2025</strong> to <strong>January 1, 2026</strong>, our helpdesk will be closed.<br/>The OPTIMIS system will remain fully available and will operate without changes.<br /><br />\n  \n  In case of urgent matters, please contact us after the holiday break<br/>email: <strong>alta@alta.pl</strong><br/>phone:<strong>(+48) 515 131 941</strong><br /><br />\n  Thank you for your understanding and we wish you peaceful and joyful holidays!<br /><br />\n  \n  This message was generated automatically - please do not reply to it.\n  <br/><br>\n  Best regards,\n  ALTA Team </p>\n  </div>',
    bodyupdate:
      '<div style="color: #000000; font-family: Arial;font-size:12pt;line-height: 1.5rem;">\n  <p>Dear Sir/Madam,<br/><br/>\n  We are pleased to inform you that we have completed the update of the <strong>OPTIMIS</strong> system, which took place on [June 30, 2025].<br />The implemented changes aim to improve functionality and user comfort.<br/><br/>Below we present the key new features:<br /><br />\n  <ol>\n  <li><strong>New user interface</strong>: Refreshed look and more intuitive navigation.</li>\n  <li><strong>Performance improvement</strong>: Reduced loading time and faster data processing.</li>\n  <li><strong>New features</strong>: Added [e.g., ability to personalize settings, integration with new tools, real-time reports].</li>\n  <li><strong>Enhanced security</strong>: Additional safeguards have been implemented to protect user data.</li>\n  </ol>\n  \n  The system is fully available and all functions work as intended.<br/><br/>If you have any questions or need support, please contact our team<br/>email: <strong>alta@alta.pl</strong><br/>phone:<strong>(+48) 515 131 941</strong><br /><br />\n  Thank you for your trust and we invite you to explore the new system capabilities!<br /><br />\n  \n  This message was generated automatically - please do not reply to it.\n  <br/><br>\n  Best regards,\n  ALTA Team </p>\n  </div>',
    subjectbreak: "Technical Maintenance",
    subjectsys: "Holiday Break",
    subjectupdate: "Software Update",
  },
  ExaminationAssignmentView: {
    header: "Assign assessment",
    labels: {
      chooseExaminationType: "Select an assessment type",
      chooseLawBase: "Select a legal basis",
      description: "Description",
      legalBase: "Legal basis",
      methodologyTest2Arms:
        "TEST2ARMS - psychological testing methodology, licensed activity",
      methodologyTest2Drive:
        "TEST2DRIVE - methodology for conducting driver examinations in transport psychology",
      methodologyTest2Safe:
        "TEST2SAFE - psychological testing methodology for security staff and detectives",
      methodologyTest2Work:
        "TEST2WORK - psychological testing methodology in occupational medicine",
      methodologyTest2SafeTlt: "TEST2SAFE",
      methodologyTest2DriveTlt: "TEST2DRIVE",
      methodologyTest2ArmsTlt: "TEST2ARMS",
      methodologyTest2WorkTlt: "TEST2WORK",
      methodologyTest2SafeDesc:
        "psychological testing methodology for security staff and detectives",
      methodologyTest2DriveDesc:
        "methodology for conducting driver examinations in transport psychology",
      methodologyTest2ArmsDesc:
        "psychological testing methodology, licensed activity",
      methodologyTest2WorkDesc:
        "psychological testing methodology in occupational medicine",
      reason: "Purpose of the assessment",
      suggestedTestMethods: "PROPOSED METHODICAS",
      freeCredits: "available credits: ",
      lockedCredits: "credits locked in assigned examinations: ",
      selectedTestCredits: "credits for selected tests: ",
    },
    license: "The test is not available in the assigned license",
    testAlreadyInExamination:
      "This test is already available in the examination",
    popup: {
      checkbox: "Remember your selection",
      content: "Are you sure you want to disable these tests?",
      header:
        "Some tests recommended for the selected methodic have been disabled.",
      headerCredits: "Warning",
      contentCredits:
        "Cannot select test because the sum of credits for selected tests exceeds the number of available credits.",
    },
  },
  ExaminationList: {
    deletePopup: {
      confirmationText: "Yes, I want to delete the assessment",
      contentText:
        "Once an assessment is deleted, it will not be possible to restore it",
      headerText: "Are you sure you want to delete the assessment?",
    },
    noTestsPopup: {
      headerText: "No tests to add",
      content:
        "No more tests can be added to this assessment. All tests available in your license are already assigned to this assessment.",
    },
    kebabMenu: {
      delete: "Delete assessment",
    },
    labels: {
      assign: "Assigned",
      assignDate: "Assigned date",
      assignDateMobile: "Added",
      contract: "Contract",
      create: "Created",
      createDate: "Created date",
      documentation: "Documentation",
      end: "Ended",
      endDate: "Ended date",
      identificator: "ID",
      interview: "Interview",
      language: "Language",
      nameArchiveExamination: "Battery name",
      nameExamination: "Assessment name",
      start: "Started",
      startDate: "Started date",
      testCnt: "Tests",
      creditsCnt: "Credits",
      extendExamMobile: "Add tests",
      recalculateExamMobile: "Recalculate",
      examTlt: "Examination contains:",
      methodologyNameTlt: "methodologies:",
      testNameTlt: "tests:",
    },
    toolTip: {
      contract: "Generate contract",
      delete: "Delete",
      documentation: "Documentation",
      interview: "Interview",
      blocked: "examination blocked due to insufficient credits",
      extendExam: "Add tests to examination",
      extendExamHidden: "Feature hidden (SHOW_EXTENDED_EXAM=0)",
      recalculateExam: "Recalculate examination",
      recalculateExamHidden:
        "Feature hidden (SHOW_RECALCULATE_EXAM=0 or lab administrator required)",
    },
    withoutLegalBasis: "Assessment without a legal basis",
  },
  ExaminationView: {
    aimsKind: {
      aimKind_1: "Psychological opinion - detectives",
      aimKind_10:
        "Certificate - licensed activity for military or police purposes",
      aimKind_11: "Certificate - licensed activity for civilian purposes",
      aimKind_12:
        "Appeal certificate - licensed activity for civilian purposes",
      aimKind_13: "Certificate - occupational medicine",
      aimKind_14:
        "Certificate - occupational medicine mining and mining rescue",
      aimKind_15: "Certificate - occupational medicine train driver license",
      aimKind_16:
        "Certificate - driver category C1, C1+E, C, C+E, D1, D1+E, D and D+E or tram driving",
      aimKind_17:
        "Certificate - driver license reinstatement category AM, A1, A2, A, B1, B, B+E and T",
      aimKind_18:
        "Certificate - driver license reinstatement psychological contraindications",
      aimKind_19:
        "Certificate - license extension category C1, C1+E, C, C+E, D1, D1+E, D and D+E or tram driving",
      aimKind_20: "Certificate - driver post-accident examination",
      aimKind_21:
        "Certificate - driver examination after alcohol or similar substances consumption",
      aimKind_22: "Certificate - driver examination after exceeding 24 points",
      aimKind_23: "Certificate - driver examination after at least 2 offenses",
      aimKind_24:
        "Certificate - driver examination psychological contraindications",
      aimKind_25: "Certificate - emergency vehicle driver",
      aimKind_26:
        "Certificate - driver post-accident examination (referred by starost)",
      aimKind_27: "Certificate - performing instructor duties",
      aimKind_28: "Certificate - performing examiner duties",
      aimKind_29:
        "Certificate - driver student or candidate for secondary school category C or C+E",
      aimKind_3: "Certificate - physical security worker",
      aimKind_30:
        "Certificate - driver student or candidate for vocational course category C or C+E",
      aimKind_31: "Certificate - professional driver referred by employer",
      aimKind_32: "Certificate - self-employed professional driver",
      aimKind_8: "Appeal certificate - physical security worker",
      aimKind_9: "Certificate - firearms permit",
    },
    breadcrumbs: {
      archive: "Archival assessments",
    },
    common: {
      unavailableInLanguageOption:
        "Not available in the selected language version.",
    },
    details: {
      createDate: "Created date",
      endDate: "Ended date",
      identificator: "Assessment ID",
      language: "Language",
      name: "Assessment name",
      startDate: "Started date",
      type: "Battery name",
    },
    header: "Dokumentation",
    labels: {
      details: "Details",
      download: "Download",
      edit: "Edit",
      generate: "Generate",
      name: "Test name",
      nameFile: "File name",
      print: "Print",
      result: "Result",
      type: "Document type",
    },
    protocols: {
      language: "Protocols language",
      testProtocol: "Test protocol",
      noProtocol: "No test protocols for the selected examination",
    },
    tabs: {
      documentation: "Documentation",
      protocols: "Protocols",
      reports: "Reports",
    },
  },
  ExamineeList: {
    labels: {
      added: "Added",
      allFinishExam: "Assigned / done",
      contract: "Contract",
      examine: "Assessment",
      examineLastDate: "Last assessment date",
      firstName: "First name",
      folder: "Folder",
      lastName: "Lastname",
      peselSlashIdentifier: "PESEL / ID",
      profile: "View profile",
      profileShort: "Profile",
    },
  },
  ExamineeManagment: {
    breadcrumbs: {
      add: "Add participant",
      dashboard: "User panel",
      directories: "Managing Participant folders",
      edit: "Edit participant",
      import: "Import examinees",
    },
    header: {
      add: "Add participant",
      edit: "Edit participant",
      editMobile: "Edit data",
      import: "Import examinees",
    },
    importExaminees: {
      collapse: "collapse",
      errors: {
        fileReadFailed: "File reading failed.",
        invalidPesel: "Import file contains invalid PESEL numbers.",
        invalidPeselFound: "Import file contains invalid PESEL numbers.",
        readFileError: "Error reading file content.",
      },
      expand: "expand",
      fileDesc:
        "To import data, a CSV file is required. Please ensure your file meets the following criteria:",
      fileDesc1: "1. Header:",
      fileDesc10: "Last name.",
      fileDesc11: "pesel:",
      fileDesc12: "PESEL number. Leave blank if you do not want to provide it.",
      fileDesc13: "sex:",
      fileDesc14: "Gender - enter male or female.",
      fileDesc15: "birthday:",
      fileDesc16: "Date of birth in yyyy-mm-dd format (e.g., 1985-03-21).",
      fileDesc17: "Example of CSV file content:",
      downloadCsvExample: "Download example CSV file",
      fileDesc18: "firstname,lastname,pesel,sex,birthday,anonymous,email,phone",
      fileDesc19: "John,Smith,85032112345,male,1985-03-21,0",
      fileDesc2:
        "The first row of the file must contain exactly the following column names:",
      fileDesc20: "Anna,Johnson,,female,1992-07-10,0",
      fileDesc21: "Anonymous,Examinee,,male,1995-12-25,1",
      fileDesc22: "Example explanation:",
      fileDesc23: "The first row is the required header.",
      fileDesc24: "The second row contains complete data for John Smith.",
      fileDesc25:
        "The third row contains data for Anna Johnson, but the pesel field is intentionally left blank because we won't provide the PESEL number for this person.",
      fileDesc26: "The fourth row contains complete data for Peter Green.",
      fileDesc27:
        "Please prepare the file according to the above instructions to ensure successful data import.",
      fileDesc28: "anonymous:",
      fileDesc29:
        "Anonymous examinee. 1 - anonymous examinee, will not be asked for consent to process personal data, cannot have a PESEL. 0 - examinee with personal data",
      fileDesc3: "firstname, lastname, pesel, sex, birthday, anonymous",
      fileDesc30: "email:",
      fileDesc31: "Email address. Leave empty if you don't want to provide it.",
      fileDesc32: "phone:",
      fileDesc33: "Phone number. Leave empty if you don't want to provide it.",
      fileDesc4: "2. Data:",
      fileDesc5:
        "Each subsequent row should contain data for one person, according to the order of columns in the header.",
      fileDesc6: "3. Data formatting:",
      fileDesc7: "firstname:",
      fileDesc8: "First name.",
      fileDesc9: "lastname:",
      filePattern: "Import file format",
      importFile: "download CSV file",
      noFileSelected: "-",
      saveSuccess: "Examinees successfully imported.",
      success: "Import file successfully loaded.",
      tltFileSelected: "import file preview: ",
    },
  },
  ExamineeView: {
    anonymity: "Anonymous",
    drivingLicense: {
      a: "A",
      a1: "A1",
      a2: "A2",
      am: "AM",
      b: "B",
      b1: "B1",
      be: "B+E",
      c: "C",
      c1: "C1",
      c1e: "C1+E",
      ce: "C+E",
      d: "D",
      d1: "D1",
      d1e: "D1+E",
      de: "D+E",
      t: "T",
      tramwaj: "TRAMWAY",
    },
    emptyState: {
      header: "There are no assessments assigned to this participant",
      info: "To see the list of assessment, assign at least one assessment.",
    },
    kebabMenu: {
      delete: "Delete participant",
      edit: "Edit participant data",
    },
    tabs: {
      archive: "Archival assessments",
      data: "Participant data",
      examination: "Assessments",
    },
    translations: {
      basicIndustry: "basic industry education",
      basicVocational: "basic vocational education",
      female: "female",
      higher: "higher education",
      id_card: "ID card",
      lowerSecondary: "junior high education",
      male: "male",
      passport: "passport",
      primary: "primary education",
      secondary: "secondary education",
      secondaryIndustry: "secondary vocational education",
    },
    userData: {
      address: "Address",
      birthDate: "Date of birth",
      defaultAnonFirstName: "Examinee",
      defaultAnonLastName: "Anonymous",
      drivingLicense: "Driving license category",
      drivingLicenseIssuer: "The entity issuing the driving license",
      education: "Education",
      email: "Email address",
      examineName: "FirstName and Lastname",
      identificator: "ID",
      identityCard: "Identity document",
      pesel: "PESEL",
      phone: "Phone number",
      serialNumber: "Serie and number",
      sex: "Gender",
    },
  },
  ExportResults: {
    exportActivities: "Export to XLS file",
    header: "Export examination results",
    headerMobile: "Export examination results",
    popups: {
      delete: {
        confirmationHeader: "Are you sure you want to delete the export file?",
        confirmationText:
          "After deleting the export file, it will not be possible to restore it.",
        confirmationCheckboxLabel: "Yes, I want to delete the export file",
      },
    },
  },
  StatsExport: {
    popups: {
      delete: {
        confirmationHeader: "Are you sure you want to delete the stats file?",
        confirmationText:
          "After deleting the stats file, it will not be possible to restore it.",
        confirmationCheckboxLabel: "Yes, I want to delete the stats file",
      },
    },
  },
  FormLabels: {
    currentPassword: "Current password",
    email: "Email",
    newPassword: "New password",
    password: "Password",
    pin: "PIN",
  },
  FormValidation: {
    Password: {
      camelCase: "a capital letter",
      length: "Minimum %lenght% characters",
      number: "a number",
      settings: "Must contain:",
      spacialChar: "a special character",
    },
    Pin: {
      length: "Field must have only 4 digit characters",
    },
    max: "The name cannot contain more than 128 characters",
    required: "This field is required",
  },
  FormValidationErrors: {
    email: "The entered value is not an email address",
    required: "This field is required",
    passwordMinLength:
      "Your password must be at least %{minLength} characters long",
    passwordRequirements:
      "Your password does not meet all the required conditions",
    pinLength: "PIN must be exactly 4 digits long",
    pinDigitsOnly: "PIN can only contain digits",
  },
  Format: {
    ExamineeViewDateFormat: "MM/DD/YYYY",
    FormDateFormat: "MM/DD/YYYY",
    ViewDateTime: "MM/DD/YYYY HH:mm",
  },
  Forms: {
    adminFields: {
      activityDetails: "Details",
      activityName: "activity",
      address: "Street and house number",
      cin: "Registration number",
      city: "City",
      clientId: "Client ID",
      dateExpire: "Account expiry date",
      dateFrom: "range from",
      dateLicExpire: "License expiry date",
      dateTo: "range to",
      email: "Email",
      examineesCnt: "Examinees",
      firstName: "First name",
      isActive: "Account status",
      isStaff: "Role",
      isSuperuser: "User with administrator privileges",
      isAdmin: "Administrator",
      allowAllAccounts: "Access to all accounts",
      allowAllOwnAndCreated: "Access to own account and created accounts",
      lastName: "Last name",
      licMethodologies: "Available methodologies",
      licTests: "Available tests",
      methodologyTlt: "Methodology",
      name: "Name",
      no: "no",
      password: "Password",
      pin: "PIN code",
      postalCode: "postal code",
      pwdCamelCase: "Uppercase and lowercase letters",
      pwdLength: "Password length",
      pwdNumbers: "Digit",
      pwdSpecialChar: "Special character",
      creditsLic: "Credit license",
      credits: "Credits",
      remainingCredits: "Remaining credits",
      allCredits: "Purchased credits",
      lockedCredits: "Credits locked in examinations",
      status: "status",
      testCogTlt: "cognitive tests",
      testPersonTlt: "personality tests",
      testPsychMotorTlt: "psychomotor tests",
      theme: "Appearance",
      tin: "Tax ID",
      usersCnt: "Users",
      yes: "yes",
    },
    adminOptions: {
      admin: {
        admin: "administrator",
        baseuser: "registrar",
        user: "user",
      },
      status: {
        active: "active",
        disabled: "inactive",
      },
      theme: {
        defaultTheme: "default",
        optimisTheme: "optimis",
      },
    },
    adminSnackbar: {
      email_unique_error: "This email address already exists in the database!",
      email_wrong_error: "The provided email address is invalid!",
      invalidDate: "Send date cannot be earlier than current date",
      parametersSaved: "Parameters saved successfully",
      required: "Please fill in all required fields.",
    },
    anonymous: "Anonymous test",
    emailSender: {
      dateSend: "send date",
      emailSentSuccessed:
        "Messages have been saved and will be sent at the scheduled time",
      emailType: "message type",
      muiRTEtextPlaceHolder: "Message content",
      subject: "subject",
      userLang: "user language",
      user: "user",
      admin: "administrator",
      staff: "registrar",
    },
    exportResults: {
      confidenceLevel: "confidence interval",
      dateFrom: "date from",
      dateTo: "date to",
      examineeAge: "age",
      examineeData: "examinee data",
      examineeEdu: "education",
      examineeName: "first and last name",
      examineeFolder: "folder name",
      examineeId: "ID/identifier",
      examineeLab: "client name",
      examineeSex: "sex",
      exportDeletedFileSucceeded: "The export file has been deleted.",
      exportSucceeded:
        "Export request has been accepted. You will receive an email about its completion (success or error).",
      filesRefresh: "refresh",
      filesToDownload: "Files to download:",
      folders: "folders",
      genres: "diagnostic areas",
      noFiles: "No files to display.",
      norm: "normalized results",
      normStd: "normalized results - confidence intervals",
      norms: "norm",
      protocol: "interview",
      psychLabs: "clients",
      raw: "raw results",
      rawStd: "raw results - confidence intervals",
      resultsData: "results",
      tests: "tests",
    },
    statsExport: {
      exportSucceeded:
        "Stats export request has been accepted. You will receive an email about its completion (success or error).",
      deletedFileSucceeded: "The stats file has been deleted.",
      filesToDownload: "Stats files to download:",
      noFiles: "No stats files to display.",
      filesRefresh: "refresh",
      rangeRequired: "Please select a date range (from and to).",
    },
    extraFields: "Supplementary data",
    fields: {
      additionalInfo: "Additional information",
      address: "Address",
      age: "Age",
      appealAuthority: "Name of the institution",
      appealDeadline: "Date",
      birthDate: "Date of birth",
      city: "City",
      country: "Country",
      date: "Date",
      diffrentIdentificationNumber: "Different ID",
      directory: "Folder",
      documentDate: "Date of issue",
      drivingLicense: "Driving license category",
      drivingLicenseIssuer: "Entities issuing driving licenses",
      education: "Education",
      email: "Email address",
      examineeRegistryId: "Number in the register",
      identificationNumber: "PESEL",
      identityDocumentNumber: "Serie and number",
      identityDocumentType: "Identity document",
      institutionName: "Name of the institution",
      interval: "Select a confidence interval",
      judgmentNumber: "Judgment number",
      lang: "Language",
      languageReport: "Select report language",
      legalBasis: "Legal basis",
      months: "months",
      name: "First name",
      nextExamination: "Date of next examination",
      phone: "Phone number",
      postalCode: "Zip code",
      recipient: "Select a recipient",
      sex: "Gender",
      standard: "Select norm",
      surname: "Last name",
      year: "Year",
      years: "Years",
      testName: "Test name",
      credits: "Customer price",
      creditsGlobal: "Price",
      value: "Value",
      values: "Values",
    },
    options: {
      activities: {
        ADMIN_CHANGE_LAB_ID: "Administrator logged into client account",
        ADMIN_LICENCE_ADDED: "Client account license added",
        ADMIN_LICENCE_CHANGED: "Client account license changed",
        ADMIN_LICENCE_DELETED: "Client account license deleted",
        ADMIN_LOGGED_IN: "Administrator logged in",
        ADMIN_LOGGED_OUT: "Administrator logged out",
        ADMIN_PSYCHOLOGICAL_LAB_ADDED: "Client account added",
        ADMIN_PSYCHOLOGICAL_LAB_CHANGED: "Client account data modified",
        ADMIN_PSYCHOLOGICAL_LAB_DELETED: "Client account deleted",
        ADMIN_USER_ADDED: "User added to client account",
        ADMIN_USER_CHANGED: "Client account user data changed",
        ADMIN_USER_DELETED: "User deleted from client account",
        ALL: "all",
        ALL_ITEMS: "All activities",
        APP_REGISTRATION: "Application registration",
        AUDIT_ERROR: "Activity log error",
        CONSOLE_PIN_VERIFICATION: "PIN verification on user console",
        CONTRACT_DOWNLOADED: "Contract downloaded",
        DIRECTORY_CREATED: "Directory created",
        DIRECTORY_DELETED: "Directory deleted",
        DIRECTORY_NAME_CHANGED: "Directory name changed",
        EXAMINATION_ASSIGNED: "Examination assigned",
        EXAMINATION_DELETED: "Examination deleted",
        EXAMINATION_PROTOCOLS_ZIP_DOWNLOADED:
          "Examination protocols ZIP downloaded",
        EXAMINATION_PROTOCOL_DOWNLOADED: "Examination protocol downloaded",
        EXAMINATION_REPORT_DOWNLOADED: "Report documents downloaded",
        EXAMINATION_STARTED: "Examination started",
        EXAMINATION_TERMINATED: "Examination terminated",
        EXAMINEE_ADDED: "Subject added",
        EXAMINEE_DATA_CHANGE: "Subject data changed",
        EXAMINEE_DELETED: "Subject data deleted",
        EXAMINEE_MOVED_TO_DIFFERENT_DIRECTORY:
          "Subject data moved to different directory",
        IMPORT_EXAMINEE: "Examinees data import",
        INTERVIEW_CHANGED: "Interview changed",
        INTERVIEW_DOWNLOADED: "Interview downloaded",
        PASSWORD_CHANGE: "Password change",
        PASSWORD_CHANGE_EXPIRED: "Password change after expiration",
        PASSWORD_CHANGE_REQUEST: "Password change request",
        PIN_CHANGE: "PIN change",
        SAVE_AGREEMENTS:
          "Saving consent for examination and personal data processing",
        TEST_RESULT_SUBMITTED: "Test results submitted",
        TEST_SKIPPED: "Test skipped on console",
        USER_LOGGED_IN: "User logged in",
        USER_LOGGED_OUT: "User logged out",
        ADMIN_PRICELIST_CHANGED: "Global pricelist modification",
        ADMIN_LAB_ANONYMIZED: "Data anonymization",
        EXPORT_RESULTS_GENERATED: "Export results generated",
        EXPORT_FILE_DOWNLOADED: "Export results file downloaded",
        EXPORT_FILE_DELETED: "Export results file deleted",
        LAB_PARAMS_BULK_UPDATED: "Lab parameters update",
        EXAMINATION_DOCUMENT_DOWNLOADED: "Examination document downloaded",
        EXAMINATION_DOCUMENT_CHANGED: "Examination document changed",
        EXAMINATION_EXTENDED: "Examination extended with new tests",
        IMPORT_EXAMINEE_AND_ASSIGNED_EXAMINATION:
          "Examinees import and examinations assigned",
        TEST_TYPE_CREDITS_UPDATED: "Client test pricelist modification",
        LICENSE_CREDITS_DEDUCTED: "Credits deduction on test results save",
      },
      activitiesStatus: {
        ok: "ok",
        server_error: "server error",
        user_error: "user error",
      },
      bool: {
        false: "No",
        true: "Yes",
      },
      country: {
        afghanistan: "Afghanistan",
        albania: "Albania",
        algeria: "Algeria",
        americanSamoa: "American Samoa",
        andorra: "Andorra",
        angola: "Angola",
        anguilla: "Anguilla",
        antarctica: "Antarctica",
        antiguaAndBarbuda: "Antigua and Barbuda",
        argentina: "Argentina",
        armenia: "Armenia",
        aruba: "Aruba",
        australia: "Australia",
        austria: "Austria",
        azerbaijan: "Azerbaijan",
        bahamas: "Bahamas",
        bahrain: "Bahrain",
        bangladesh: "Bangladesh",
        barbados: "Barbados",
        belarus: "Belarus",
        belgium: "Belgium",
        belize: "Belize",
        benin: "Benin",
        bermuda: "Bermuda",
        bhutan: "Bhutan",
        bolivia: "Bolivia",
        bonaireSintEustatiusAndSaba: "Bonaire, Sint Eustatius and Saba",
        bosniaAndHerzegovina: "Bosnia and Herzegovina",
        botswana: "Botswana",
        bouvetIsland: "Bouvet Island",
        brazil: "Brazil",
        britishIndianOceanTerritory: "British Indian Ocean Territory",
        bruneiDarussalam: "Brunei Darussalam",
        bulgaria: "Bulgaria",
        burkinaFaso: "Burkina Faso",
        burundi: "Burundi",
        cambodia: "Cambodia",
        cameroon: "Cameroon",
        canada: "Canada",
        capeVerde: "Cape Verde",
        caymanIslands: "Cayman Islands",
        centralAfricanRepublic: "Central African Republic",
        ceuta: "Ceuta",
        chad: "Chad",
        chile: "Chile",
        china: "China",
        christmasIsland: "Christmas Island",
        cocosIslands: "Cocos (Keeling) Islands",
        colombia: "Colombia",
        comoros: "Comoros",
        congo: "Congo (Rep.)",
        cookIslands: "Cook Islands",
        costaRica: "Costa Rica",
        coteDivoire: "Cote D’Ivoire",
        croatia: "Croatia",
        cuba: "Cuba",
        curacao: "Curaçao",
        cyprus: "Cyprus",
        czechRepublic: "Czechia",
        democraticRepublicOfTheCongo: "Congo (Dem. Rep.)",
        denmark: "Denmark",
        djibouti: "Djibouti",
        dominica: "Dominica",
        dominicanRepublic: "Dominican Republic",
        ecuador: "Ecuador",
        egypt: "Egypt",
        elSalvador: "El Salvador",
        equatorialGuinea: "Equatorial Guinea",
        eritrea: "Eritrea",
        estonia: "Estonia",
        ethiopia: "Ethiopia",
        falklandIslands: "Falkland Islands (Malvinas)",
        faroeIslands: "Faroe Islands",
        fiji: "Fiji",
        finland: "Finland",
        france: "France",
        frenchPolynesia: "French Polynesia",
        frenchSouthernTerritories: "French Southern Territories",
        gabon: "Gabon",
        gambia: "Gambia",
        georgia: "Georgia",
        germany: "Germany",
        ghana: "Ghana",
        gibraltar: "Gibraltar",
        greece: "Greece",
        greenland: "Greenland",
        grenada: "Grenada",
        guam: "Guam",
        guatemala: "Guatemala",
        guinea: "Guinea",
        guineaBssau: "Guinea-Bissau",
        guyana: "Guyana",
        haiti: "Haiti",
        heardAndMcdonaldIslands: "Heard and McDonald Islands",
        honduras: "Honduras",
        hongKong: "Hong Kong",
        hungary: "Hungary",
        iceland: "Iceland",
        india: "India",
        indonesia: "Indonesia",
        iran: "Iran, Islamic Republic of",
        iraq: "Iraq",
        ireland: "Ireland",
        israel: "Israel",
        italy: "Italy",
        jamaica: "Jamaica",
        japan: "Japan",
        jordan: "Jordan",
        kazakhstan: "Kazakhstan",
        kenya: "Kenya",
        kiribati: "Kiribati",
        koreaNorth: "Korea, Democratic People’s Republic of",
        kosovo: "Kosovo",
        kuwait: "Kuwait",
        kyrgyztan: "Kyrgyztan",
        lao: "Lao, People’s Democratic Republic of",
        latvia: "Latvia",
        lebanon: "Lebanon",
        lesotho: "Lesotho",
        liberia: "Liberia",
        libyan: "Libyan Arab Jamahiriya",
        liechtenstein: "Liechtenstein",
        lithuania: "Lithuania",
        luxembourg: "Luxembourg",
        macao: "Macao",
        madagascar: "Madagascar",
        malawi: "Malawi",
        malaysia: "Malaysia",
        maldives: "Maldives",
        mali: "Mali",
        malta: "Malta",
        marshallIslands: "Marshall Islands",
        mauritania: "Mauritania",
        mauritius: "Mauritius",
        mayotte: "Mayotte",
        melilla: "Melilla",
        mexico: "Mexico",
        micronesia: "Micronesia, Federal States of",
        moldova: "Moldova, Republic of",
        mongolia: "Mongolia",
        montenegro: "Montenegro",
        montserrat: "Montserrat",
        morocco: "Morocco",
        mozambique: "Mozambique",
        myanmar: "Myanmar",
        namibia: "Namibia",
        nauru: "Nauru",
        nepal: "Nepal",
        netherlands: "Netherlands",
        newCaledonia: "New Caledonia",
        newZealand: "New Zealand",
        nicaragua: "Nicaragua",
        niger: "Niger",
        nigeria: "Nigeria",
        niue: "Niue",
        norfolk: "Norfolk Island",
        northernMacedonia: "North Macedonia",
        northernMarianaIslands: "Northern Mariana Islands",
        norway: "Norway",
        oman: "Oman",
        pakistan: "Pakistan",
        palau: "Palau",
        palestinian: "Palestinian Territory, Occupied",
        panama: "Panama",
        papuaNewGuinea: "Papua New Guinea",
        paraguay: "Paraguay",
        peru: "Peru",
        philippines: "Philippines",
        pitcairn: "Pitcairn",
        poland: "Poland",
        portugal: "Portugal",
        qatar: "Qatar",
        romania: "Romania",
        russia: "Russian Federation",
        rwanda: "Rwanda",
        saintBarthelemy: "Saint Barthelemy",
        samoa: "Samoa",
        sanMarino: "San Marino",
        saoTomeAndPrincipe: "Sao Tome and Principe",
        saudiArabia: "Saudi Arabia",
        senegal: "Senegal",
        serbia: "Serbia",
        seychelles: "Seychelles",
        sierraLeone: "Sierra Leone",
        singapore: "Singapore",
        sintMaartenDutch: "Sint Maarten (Dutch part)",
        slovakia: "Slovakia",
        slovenia: "Slovenia",
        solomonIslands: "Solomon Islands",
        somalia: "Somalia",
        southAfrica: "South Africa",
        southGeorgiaAndSouthSandwichIslands:
          "South Georgia and South Sandwich Islands",
        southKorea: "Korea, Republic of",
        southSudan: "South Sudan",
        spain: "Spain",
        sriLanka: "Sri Lanka",
        stHelena: "St.Helena",
        stKittsandAndNevis: "St.Kittsand and Nevis",
        stLucia: "St.Lucia",
        stPierreAndMiquelon: "St Pierre and Miquelon",
        stVincentAndTheGrenadines: "St Vincent and the Grenadines",
        sudan: "Sudan",
        suriname: "Suriname",
        swaziland: "Swaziland",
        sweden: "Sweden",
        switzerland: "Switzerland",
        syrian: "Syrian Arab Republic",
        taiwan: "Taiwan, Provice of China",
        tajikistan: "Tajikistan",
        tanzania: "Tanzania, United Republic of.",
        thailand: "Thailand",
        timorLeste: "Timor Leste",
        togo: "Togo",
        tokelau: "Tokelau",
        tonga: "Tonga",
        trinidadAndTobago: "Trinidad and Tobago",
        tunisia: "Tunisia",
        turkey: "Turkey",
        turkmenistan: "Turkmenistan",
        turksAndCaicosIslands: "Turks and Caicos Islands",
        tuvalu: "Tuvalu",
        uganda: "Uganda",
        ukraine: "Ukraine",
        unitedArabEmirates: "United Arab Emirates",
        unitedKingdom: "United Kingdom",
        unitedKingdomNorthernIreland: "United Kingdom (Northern Ireland)",
        unitedStatesOfAmerica: "United States of America",
        uruguay: "Uruguay",
        usMinorOutlyingIslands: "U.S. Minor Outlying Islands",
        uzbekistan: "Uzbekistan",
        vanuatu: "Vanuatu",
        vatican: "Vatican City State",
        venezuela: "Venezuela",
        vietnam: "Vietnam",
        virginIslandsBritish: "Virgin Islands (British)",
        virginIslandsUSA: "Virgin Islands (USA)",
        wallisAndFutuna: "Wallis and Futuna Islands",
        westernSahara: "Western Sahara",
        yemen: "Yemen",
        zambia: "Zambia",
        zimbabwe: "Zimbabwe",
      },
      education: {
        basicIndustry: "Basic industry education",
        basicVocational: "Basic vocational education",
        higher: "Higher education",
        lowerSecondary: "Junior high education",
        primary: "Primary education",
        secondary: "Secondary education",
        secondaryIndustry: "Secondary vocational education",
      },
      emailType: {
        break: "technical maintenance",
        system: "information",
        update: "update",
      },
      exportResultConfidenceLevel: {
        item_85: "0.85",
        item_9: "0.9",
        item_95: "0.95",
        item_99: "0.99",
      },
      genres: {
        cognitive: "cognitive and intellectual processes",
        personality: "personality",
        psychomotor: "psychomotor skills",
      },
      identityDocument: {
        idCard: "ID card",
        passport: "Passport",
      },
      lang: {
        english: "English",
        espaniol: "Spanish",
        mexico: "Mexican Spanish",
        polish: "Polish",
        russian: "Russian",
        ukrain: "Ukrainian",
      },
      languagesDocumentation: {
        en: "english",
        pl: "polish",
      },
      norms: {
        norm_1: "OPT_1.0.PL",
        norm_2: "OPT_1.0.UA",
        norm_3: "OPT_1.0.RU",
      },
      recipient: {
        examinee: "Participant",
        psychologist: "Psychologist",
        specialist: "Specialist",
      },
      sex: {
        female: "Female",
        male: "Male",
      },
    },
    passwordFields: "Password settings",
    pwdFields: "Password Policy",
    requiredFields: "Mandatory data",
    selectAll: "select all",
    snackbar: {
      peselLength: "PESEL must consist of 11 digits",
      peselNumber: "PESEL may only consist of numbers",
      required: "All required fields must be filled out",
    },
  },
  HelpDocs: {
    contractFileName1: "/help-documents/pl-pl/kontrakt_psychologiczny_2024.pdf",
    contractFileName2:
      "/help-documents/pl-pl/kontrakt_psychologiczny_ru_2024.pdf",
    contractFileName3:
      "/help-documents/pl-pl/kontrakt_psychologiczny_ua_2024.pdf",
    contractFileName4:
      "/help-documents/pl-pl/polityka_ochrony_danych_osobowych_klauzula_informacyjna_2024.pdf",
    contractName1: "Psychological Contract 2024",
    contractName2: "Psychological Contract RU 2024",
    contractName3: "Psychological Contract UA 2024",
    contractName4: "Personal Data Protection Policy - Information Clause 2024",
    contractTitle: "Contracts",
    handbookFileName1:
      "/help-documents/pl-pl/charakterystyka_obszarow_diagnozy.pdf",
    handbookFileName2: "/help-documents/pl-pl/testy_psychomotoryczne.pdf",
    handbookFileName3: "/help-documents/pl-pl/testy_poznawcze.pdf",
    handbookFileName4: "/help-documents/pl-pl/testy_osobowosci.pdf",
    handbookFileName5: "/help-documents/pl-pl/katalog_testow_03_2024.pdf",
    handbookName1: "Characteristics of Diagnostic Areas",
    handbookName2: "Psychomotor Tests",
    handbookName3: "Cognitive Tests",
    handbookName4: "Personality Tests",
    handbookName5: "Test Catalog 03-2024",
    handbookTitle: "Handbook and Test Catalog",
    modulesFileName1: "/help-documents/pl-pl/sytuacja_zdrowotna.pdf",
    modulesFileName10:
      "/help-documents/pl-pl/psychologia_transportu_kierowanie pojazdami_mtd_IV.pdf",
    modulesFileName2: "/help-documents/pl-pl/sytuacja_spoleczna_i_rodzinna.pdf",
    modulesFileName3: "/help-documents/pl-pl/obserwacja.pdf",
    modulesFileName4: "/help-documents/pl-pl/detektywi_ochrona_bron_mtd_I.pdf",
    modulesFileName5: "/help-documents/pl-pl/koncesja_mtd_II.pdf",
    modulesFileName6: "/help-documents/pl-pl/medycyna_pracy_mtd_III.pdf",
    modulesFileName7: "/help-documents/pl-pl/kierowcy_sluzbowi_mtd_III.pdf",
    modulesFileName8: "/help-documents/pl-pl/praca_wysokosc_mtd_III.pdf",
    modulesFileName9: "/help-documents/pl-pl/wozki_widlowe_mtd_III.pdf",
    modulesName1: "Health Situation",
    modulesName10: "Transport Psychology Vehicle Operation MTD IV",
    modulesName2: "Social and Family Situation",
    modulesName3: "Observation",
    modulesName4: "Detectives Protection Weapons MTD I",
    modulesName5: "License MTD II",
    modulesName6: "Occupational Medicine MTD III",
    modulesName7: "Service Drivers MTD III",
    modulesName8: "Working at Heights MTD III",
    modulesName9: "Forklifts MTD III",
    modulesTitle: "Interview Modules",
    policyName1: "Personal Data Protection Policy - Information Clause 2024",
    policyTitle1: "Personal data protection policy",
  },
  Helpdesk: {
    contact: "Contact",
    text1:
      "Reports of errors or irregularities in the operation of the System should be sent electronically to the address: ",
    text2: "optimis@alta.pl",
    text3: "The technical support hotline is available on working days",
    text4: "in hours 8:00-16:00",
    documents: {
      header: "Help documents",
      labels: {
        download: "Download",
        name: "Document name",
      },
    },
    header: "Help",
    help: "Remote help",
    mobile: "mobile",
    phoneNo: "phone",
    subheader: "Help desk",
    phoneNo1: "(+48) 32 249 50 40",
    phoneNo2: "(+48) 515 131 941",
    phoneNo3: "",
    emailValue: "",
  },
  Interview: {
    header: "Interview",
    hours: "Hours",
    inputAdditionalInformation: "Enter additional information",
    inputHoursOfWork: "Enter hours worked in the last 24 hours",
    months: "Months",
    questions: {
      methodologies: {
        currentPsychophysicalState: {
          headers: {
            criticalEvents: "Critical events",
            currentState: "Current psychophysical state",
          },
          questionExtendedTexts: {
            commonText: "Describe the circumstances of this event/situation",
          },
          questionTexts: {
            question1: "Has the subject consumed alcohol in the last 48 hours?",
            question10: "Use of assistance from:",
            question10a: "a. psychologist",
            question10b: "b. psychiatrist",
            question10c: "c. neurologist",
            question11: "Disability certificate",
            question12: "Problems due to alcohol consumption",
            question13: "Stay in sobering-up station",
            question14: "Use of intoxicants/psychoactive substances/drugs",
            question15:
              "Suggestions from a doctor or someone close to seek treatment due to nervousness, absent-mindedness, or problems with memory or orientation",
            question2:
              "Has the subject worked professionally during the last or previous night?",
            question3: "Number of working hours in the last 24 hours",
            question4: "Head injury requiring medical attention",
            question5: "Loss of consciousness",
            question6: "Hospital stay",
            question7:
              "Has there ever been or is there currently treatment for/has there ever been a diagnosis of the following conditions:",
            question7a:
              "a. digestive system diseases (gastric or duodenal ulcer, intestinal dysfunction, etc.)",
            question7b:
              "b. heart and circulatory system diseases (coronary disease, high blood pressure)",
            question7c:
              "c. hearing or vision disorders (excluding corrective glasses)",
            question7d: "d. diabetes",
            question7e: "e. epilepsy",
            question7f:
              "f. mental illnesses (depression, neurosis, psychiatric treatment (inquire about psychiatric treatment of a close family member)",
            question8:
              "Regular medication use (inquire if aware of side effects and ask about other medications affecting mental functions)",
            question9: "Sleep problems",
          },
        },
        detectivesSecurityGuardsAndWeaponPermits: {
          questionAnswers: {
            question1a: "for professional purposes (detective, security guard)",
            question1b: "for hunting purposes",
            question1c: "for sports purposes",
            question1d: "for personal use",
            question1e: "for museum, commemorative, scientific purposes",
            question1f: "other",
          },
          questionTexts: {
            question1: "Primary purposes of weapon use:",
            question1g: "Which ones?",
            question2:
              "Has there ever been any use of weapons or other means of direct coercion?",
            question3:
              "How frequently have weapons been used in the last 5 years?",
          },
        },
        drivingVehicles: {
          headers: {
            drivingCharacteristics: "Route characteristics",
          },
          questionAnswers: {
            question13a: "as perpetrator/co-perpetrator",
            question13b: "as victim",
            question13c: "not applicable",
            question14a: "as perpetrator/co-perpetrator",
            question14b: "as victim",
            question14c: "not applicable",
            question15a: "hazardous materials transport",
            question15b: "passenger transport",
            question15c: "driving instructor",
            question15d: "driving examiner",
            question15e: "none",
            question3a: "less than 3,000 km annually",
            question3b: "between 3,000 – 15,000 km annually",
            question3c: "between 15,000 - 70,000 km annually",
            question3d: "above 70,000 km annually",
            question3e: "difficult to say",
            question4a: "less than 5 hours weekly",
            question4b: "between 5 - 15 hours weekly",
            question4c: "between 15 - 40 hours weekly",
            question4d: "above 40 hours weekly",
            question4e: "difficult to say",
            question5a: "I mostly drive short routes",
            question5b: "I mostly drive long routes",
            question5c: "I drive both long and short routes",
            question6a: "I usually drive fixed routes",
            question6b: "I usually drive different routes",
            question7a: "I most often drive at night",
            question7b: "I usually drive during the day",
            question7c: "I drive both during day and night",
            question8a: "I mainly drive alone without relief",
            question8b: "I most often drive with relief",
            question9a: "I mainly drive in the city",
            question9b: "I mainly drive outside the city",
          },
          questionTexts: {
            question1: "Overall driving experience",
            question10: "Driver's license suspension or revocation",
            question11: "Declaration of inability to drive",
            question12: "Penalty for traffic offense or violation",
            question13: "Involvement as driver in car accident",
            question14: "Involvement as driver in traffic collision",
            question15: "Additional qualifications and licenses",
            question2: "Professional driving experience",
            question3: "Annual mileage",
            question4: "Hours spent driving",
            question5: "Route length",
            question6: "Route variety",
            question7: "Time of day",
            question8: "Relief driver",
            question9: "Area",
          },
        },
        licensedActivity: {
          questionTexts: {
            question1:
              "Total work experience in a facility engaged in licensed activities",
            question2: "Position/performed duties",
            question3:
              "Work experience in current position in a facility engaged in licensed activities",
            question4a: "Involvement in workplace accident",
            question4b:
              "What were the causes, consequences of the accident - was there damage to property, health?",
          },
        },
        observation: {
          questionAnswers: {
            question1a:
              "Establishes very good contact with the interviewer; maintains eye contact; behaves confidently and naturally, doesn't allow themselves to be thrown off balance or become impatient, behaves spontaneously and naturally.",
            question1b:
              "Establishes contact with the interviewer; maintains eye contact; behaves naturally, although signs of some nervousness are visible.",
            question1c:
              "Behaves in a distant manner, avoids eye contact; behaves unnaturally, small stimuli cause loss of balance, clear signs of nervousness and impatience are visible.",
            question2a:
              "Formulates statements using correct language, constructs clear, readable sentences, maintains logical structure of speech, uses rich vocabulary.",
            question2b:
              "Formulates statements correctly, generally maintains their logical structure; average but correct vocabulary.",
            question2c:
              "Formulates short, perfunctory statements, often incoherent or unclear; uses incorrect phrases and formulations; sentences are very simple, vocabulary is very poor, grammatical errors occur.",
            question3a:
              "Observable very cheerful, optimistic mood; satisfaction with self and life situation.",
            question3b:
              "Observable moderate mood, fairly positive attitude and generally optimistic outlook for the future.",
            question3c:
              "Observable disproportionately strong emotional reactions, clear tendency towards pessimistic perception of the world; showing dissatisfaction.",
            question4a:
              "During examination adequately controls behavior and emotions, adequately adapts to emerging circumstances.",
            question4b:
              "During examination generally controls behavior and emotions; most often responds adequately to emerging circumstances.",
            question4c:
              "During examination observable difficulties with controlling behaviors and emotions; inadequate behaviors or emotions appear.",
          },
          questionTexts: {
            question1: "Contact with interviewer",
            question2: "Language and rhetoric",
            question3: "Mood and attitude",
            question4: "Composure and control of behavior and emotions",
          },
        },
        occupationalMedicine: {
          headers: {
            companyCarDrivers: "Company car drivers",
            forkliftOperators: "Forklift operators",
            minersAndMinerLifeguards: "Miners and mine rescuers",
            trainDriver: "Train drivers",
            workCourseInformation: "Professional career history",
            workInformation: "Professional work information",
            workingAtHeights: "Working at heights",
          },
          questionAnswers: {
            question13a: "less than 3,000 km annually",
            question13b: "between 3,000 – 15,000 km annually",
            question13c: "between 15,000 - 70,000 km annually",
            question13d: "above 70,000 km annually",
            question13e: "difficult to say",
            question14a: "less than 5 hours weekly",
            question14b: "between 5 - 15 hours weekly",
            question14c: "between 15 - 40 hours weekly",
            question14d: "above 40 hours weekly",
            question14e: "difficult to say",
            question18a: "as perpetrator/co-perpetrator",
            question18b: "as victim",
            question18c: "not applicable",
            question19a: "as perpetrator/co-perpetrator",
            question19b: "as victim",
            question19c: "not applicable",
            question5a: "Monotonous work",
            question5b: "Constant high information input",
            question5c: "High noise level",
            question5d:
              "Work with high psychological load (responsibility and decision-making)",
            question5e: "Ionizing radiation",
            question5f: "Chemical factors",
            question5g: "Other",
          },
          questionTexts: {
            question1: "Trained profession",
            question10: "Subject involved in workplace accident",
            question10a: "When? What were the health consequences?",
            question11: "Disability determined",
            question11a: "For what reason? Since when? Until when?",
            question12: "Overall driving experience",
            question13: "Annual mileage",
            question14: "Hours spent driving",
            question15: "Declaration of inability to drive",
            question16: "Driver's license suspension or revocation",
            question17: "Penalty for traffic offense or violation",
            question18: "Involvement as driver in car accident",
            question19: "Involvement as driver in traffic collision",
            question2: "Current profession",
            question20: "Qualifications for working at heights",
            question21:
              "Performance of work at heights (if yes, ask how many meters above ground)",
            question22: "Subjective feeling of fear while at heights",
            question23: "Accident while working at heights",
            question23a: "Was there damage to property or health?",
            question24: "Qualifications for forklift operation",
            question25:
              "Performance of work related to forklift operation and driving",
            question26: "Accident during forklift operation or driving",
            question26a: "Was there damage to property or health?",
            question3: "Workplace / school",
            question4: "Position / performed duties",
            question5: "Permanent harmful/burdensome factors in the workplace",
            question5f: "Which ones?",
            question5g: "Which ones?",
            question6: "Total work experience",
            question7: "Experience in current position",
            question8: "Occupational disease diagnosed",
            question8a: "When? For what reason?",
            question9: "Disability benefits granted",
            question9a: "For what reason? Since when? Until when?",
          },
        },
        socialAndFamilySituation: {
          questionTexts: {
            question1:
              "Serious work-related conflict or problem (e.g., workplace accident, reprimand, labor court, disciplinary dismissal, mobbing)",
            question2:
              "Problems during education (e.g., repeating a grade, expulsion from school, suspension of student rights)",
            question3:
              "Serious family conflict or problems in private situations (e.g., court cases, involvement in fights, may ask about relationship status, children)",
            question4:
              "Direct life-threatening situation (e.g., fire, flood, and other disasters)",
            question5:
              "Experience of physical violence against oneself (e.g., assault, theft, battery)",
            question6:
              "Involvement in social organizations (e.g., volunteering)",
            question7:
              "Criminal record (e.g., receiving a fine, court sentence)",
          },
        },
      },
      questionAnswers: {
        no: "no",
        yes: "yes",
      },
      questionTexts: {
        describeTheCircumStancesOfUsage: "Describe the circumstances of use",
        forHowLong: "Until when?",
        sinceWhen: "Since when?",
        whatAreTheConsequences: "What were the health consequences?",
        when: "When?",
        why: "For what reason?",
      },
    },
    tabs: {
      currentPsychophysicalState: "Health situation",
      drivingVehicles: "Vehicle operation",
      licensedActivities: "Licensed activities",
      observation: "Observation",
      occupationalMedicine: "Occupational medicine",
      securityAndDetectives: "Security and detective services",
      socialAndFamilySituation: "Social and family situation",
    },
    years: "Years",
  },
  Language: {
    pl: "Polish",
    ru: "Russian",
    uk: "Ukrainian",
  },
  Login: {
    Access_denied: "Access denied",
    Captcha_error: "Error completing captcha. Please try again.",
    Instance_configured_incorrectly:
      "System configuration error. Report the issue to technical support.",
    Laboratory_is_inactive_or_deleted: "Client account is inactive",
    Laboratory_account_has_expired: "Login failed — the account has expired.",
    No_recaptcha_token_provided:
      "Recaptcha error. Report the issue to technical support.",
    User_account_has_been_deleted: "User account is inactive",
    User_account_is_not_active: "User account has been deleted",
    Validation_failed: "Incorrect email or password.",
    adminHeader: "ADMIN PANEL",
    error: "Incorrect email or password.",
    header: "LOGIN",
    reset: "Reset password",
    warning: "CAPS LOCK is on",
  },
  Onboarding: {
    errorText:
      "An error occurred while setting your password, please try again later.",
    setNewPasswordInfo:
      "Enter the password you will use to log in to the system.",
    setPasswordFormLabel: "Set a password",
    setPinFormLabel: "Set PIN",
    setPinInfo:
      "Enter the PIN number you will use to log in to the administrator panel.",
    success:
      "Your password and PIN have been saved. You can now log in to the application for the first time using your email address and password.",
    successTitle: "The password and PIN have been set",
  },
  Pagination: {
    outOf: "of",
  },
  PasswordExpired: {
    form: {
      header: "Set new password",
      text: "Enter the password you will use to log in to the system.",
    },
    popup: {
      header: "Password has expired",
      text: "You will be redirected to the password reset process to set a new password.",
    },
    success: {
      header: "Password saved",
      text: "Your password has been changed. You can now proceed to the application.",
    },
  },
  PsychologicalTests: {
    cognitive: "Cognitive tests",
    personality: "Personality tests",
    psychomotor: "Psychomotor tests",
  },
  ResetPassword: {
    errorText:
      "An error occurred while resetting your password, please try again later.",
    formHeader: "Reset password",
    resetEmailSentPt1: "E-mail adress:",
    resetEmailSentPt2:
      "to which a message was sent containing instructions on the password reset process.",
    resetInfo:
      "Enter your account email address to receive a password reset link.",
    setNewPassword: "Set a new password",
    setNewPasswordInfo:
      "Enter the password you will use to log in to the system.",
    success:
      "Your password has been changed. You can now log in to the application using your email address and new password.",
    successTitle: "Password was saved",
  },
  SearchEngine: {
    enterFilter:
      "You can search by first name, last name, PESEL/ID number\nor by examination assignment date \nin YYYY-MM-DD format.",
    header: "Search examinees",
    noResults: "No search results",
    noResultsForFilter: "No examinees found matching the entered requirements.",
    placeholderDesktop:
      "First name, last name, PESEL/ID, examination assignment date (YYYY-MM-DD)",
    placeholderMobile: "Search",
    searchForExaminees: "Search examinees",
  },
  RegistryResults: {
    header: "Examinee Registry",
    headerMobile: "Examinee Registry",
    clientAccounts: "Client accounts",
    clientAccountsRequired: "At least one client account must be selected.",
    foldersRequired: "Select at least one folder.",
    legalBasisRequired: "Select at least one legal basis for the examination.",
    folders: "Folders",
    dateFrom: "Date from",
    dateTo: "Date to",
    legalBasis: "Legal bases",
    generateButton: "Generate registry",
    filesToDownload: "Files to download",
    filesRefresh: "Refresh file list",
    noFiles: "No generated files.",
    exportSucceeded:
      "Registry generation request has been accepted. You will receive an email about its completion (success or error).",
    dateRangeError: 'The "from" date cannot be later than the "to" date.',
    exportDeletedFileSucceeded: "Registry file has been deleted.",
    popups: {
      delete: {
        confirmationHeader:
          "Are you sure you want to delete the registry file?",
        confirmationText: "Once deleted, the registry file cannot be restored.",
        confirmationCheckboxLabel: "Yes, I want to delete the registry file",
      },
    },
  },
  PriceList: {
    header: "Price list",
    headerMobile: "Price list",
    testName: "Test name",
    credits: "Credits",
  },
  SendEmail: {
    header: "Sending notifications",
    headerMobile: "Sending notifications",
  },
  Snackbars: {
    createExaminationSuccess: "Examination assigned correctly",
    extendExaminationSuccess:
      "Examination successfully extended with new tests",
    recalculateExaminationSuccess: "Examination results recalculated",
    createExamineeSuccess: "Examinee added successfully",
    createMultiExaminationSuccess:
      "Examinations successfully imported and assigned",
    createPsychLabSuccess: "Client account added successfully",
    createPsychLicSuccess: "License added successfully",
    createPsychUserSuccess: "User added successfully",
    deleteExaminationSuccess: "Examination deleted correctly",
    anonymizePsychLabSuccess: "Client data anonymized successfully",
    anonymizePsychLabEmptySuccess:
      "No examinations to anonymize. Client data has been cleaned.",
    deletePsychLabSuccess: "Client account deleted successfully",
    editExamineeSuccess: "Examinee edited successfully",
    editPsychLabSuccess: "Client account edited successfully",
    editPsychLicSuccess: "License edited successfully",
    editPsychUserSuccess: "User edited successfully",
    transferUserDataSuccess:
      "Examinations and folders transferred successfully",
    failedRequest: "Problem occurred: ",
    movingExamineesSuccess: "Successfully moved to another folder",
    examineesListGeneratedSuccess: "Examinees list generated successfully",
    examineesListGeneratedError: "Failed to generate examinees list",
    deleteExamineeSuccess: "Participant deleted successfully",
    bulkDeleteExamineesSuccess: "Participants deleted successfully: %{deleted}",
    bulkDeleteExamineesPartial:
      "Deleted participants: %{deleted}. Skipped (have examinations): %{skipped}",
    passwordChangeSuccess: "Password change successful",
    pinChangeSuccess: "PIN change successful",
    success: "Action successful",
    unrecognizedError: "Unrecognized error, check internet connection",
    editTestCreditSuccess: "Test credit price successfully saved",
    editTestCreditError: "Failed to save test credit price",
    unblockedExamSuccess: "Customer examinations successfully unblocked",
  },
  LandscapePrompt: {
    title: "Rotate your device to landscape",
    description:
      "Editing documentation is not available in portrait mode. To continue, rotate your device to landscape.",
  },
  TwoFactor: {
    backupCode: "Backup code",
    backupCodes: "Backup Codes",
    backupCodesInfo:
      "Save these backup codes in a safe place. You can use them to access your account if you lose your authenticator device.",
    confirmDisable: "Enter your password to disable two-factor authentication",
    disableError: "Failed to disable two-factor authentication",
    disableSuccess: "Two-factor authentication has been successfully disabled",
    disableTitle: "Disable Two-Factor Authentication",
    enterBackupCode: "Enter backup code",
    enterCode: "Enter the verification code from your authenticator app",
    scanQRCode: "Scan this QR code with your authenticator app",
    secretKey: "Secret key",
    setupError: "Failed to set up two-factor authentication",
    setupSuccess: "Two-factor authentication has been successfully set up",
    setupTitle: "Set up Two-Factor Authentication",
    useAuthenticator: "Use authenticator",
    useBackupCode: "Use backup code",
    verificationCode: "Verification code",
    verificationError: "Invalid verification code",
    verifyTitle: "Verify Two-Factor Authentication",
  },
  UserSettings: {
    access: "Access",
    facilityInfo: "Facility Information",
    header: "Account settings",
    headerChangePassword: "Change password",
    headerChangePin: "Change PIN",
    headerMobile: "Settings",
    helpdeskMsgLab:
      "If you want to change the facility or user data, please call:",
    helpdeskMsgUser:
      "If you have any questions or problems, please contact our technical support:",
    infoSubHeaders: {
      address: "Address",
      cin: "Registration number",
      dateExpire: "Account expiry date",
      email: "Email",
      firstName: "First name",
      id: "Client ID",
      labName: "Name",
      lastName: "Last name",
      licenseNumber: "License number",
      assignedClientAccount: "Client account you are assigned to",
      tin: "Tax ID",
    },
    license: {
      license: "License",
      dateLicExpire: "License expiration date: ",
      remainingCredits: "Remaining credits: ",
      allCredits: "Purchased credits: ",
      lockedCredits: "Credits locked in examinations: ",
      freeCredits: "Available credits: ",
    },
    passwordChange: "Password Change",
    passwordExpiry: "Password expiry date:",
    pinChange: "PIN Change",
    pinChangeMobile: "PIN Change",
    pinInfo:
      "Enter the PIN number that you will use to log in to the administrator panel.",
    setNewPin: "Set new PIN",
    userInfo: "User Information",
  },
  CsvHeaders: {
    firstName: "First name",
    lastName: "Last name",
    identificationNumber: "Identifier",
    directoryName: "Folder name",
  },
  CsvFileName: {
    examineesList: "examinees-list",
  },
  SystemParams: {
    showBatteriesDesc:
      "flag indicating whether to display batteries when inviting to examination, values: 0, 1",
    t2sTestsDesc:
      "list of tests selected by default when choosing T2S methodology, example value: SIRT,CHORT,HECOR....",
    t2aTestsDesc:
      "list of tests selected by default when choosing T2A methodology, example value: SIRT,CHORT,HECOR....",
    t2wTestsDesc:
      "list of tests selected by default when choosing T2W methodology, example value: SIRT,CHORT,HECOR....",
    t2dTestsDesc:
      "list of tests selected by default when choosing T2D methodology, example value: SIRT,CHORT,HECOR....",
    selectTestsDesc:
      "list of tests selected by default when inviting without legal basis, example value: SIRT,CHORT,HECOR....",
    batteriesListDesc:
      "list of batteries visible when inviting to examination if SHOW_BATTERIES parameter is set to 1, example value: TEST2DRIVE,TEST2SPORT...",
    showExtendedExamDesc:
      "Whether to allow extending closed examinations with new tests, values: 0, 1",
    showRecalculateExamDesc:
      "Whether to show the recalculate examination action on the examination list for lab administrators (is_admin), values: 0, 1",
    showExamineeRegistryDesc:
      "Examinee registry available from the psychologist panel – whether to display the examinee registry module, values: 0, 1",
    showImportExamineeDesc:
      "Examinee import available from the psychologist panel, values: 0, 1",
    allowExportResultDesc:
      "Export results available from the psychologist panel, values: 0, 1",
    passwordExpiryDaysDesc:
      "Number of days the user password is valid (e.g. 30, 60, 90)",
    allowDelExaminessDesc:
      "Whether to allow deleting multiple examinees at once, values: 0, 1",
    allowDelExamineeWithExamDesc:
      "Whether to allow deleting an examinee together with their examinations, values: 0, 1",
    batteries: "Battery",
  },
};